// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__75","cls2":"CreateSocialItemModal-cls2_Dyh CreateSocialItemModal-cls1__75"};